export default __webpack_public_path__ + "static/media/swiftnet.1a0824e9.jpg";